var _circle, _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStopwatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 119,
    viewBox: "0 0 129 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 69,
    r: 44,
    fill: "white",
    stroke: "#91DA8B",
    strokeWidth: 12
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    width: 60,
    height: 12,
    rx: 6,
    fill: "#91DA8B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 5,
    width: 12,
    height: 19,
    fill: "#91DA8B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 42,
    width: 129,
    height: 54,
    rx: 27,
    fill: "#C4C4C4",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/stopwatch.aa5dae00deeec0b638b91b3f8e35daca.svg";
export { ForwardRef as ReactComponent };